import axios from "axios";
import { createContext, useEffect, useState } from "react";

// export const API_URL = 'http://localhost:3000/api';
// export const BASE_URL = 'http://localhost:3000';

// http://103.87.173.134:3006/
//export const API_URL = 'http://103.87.173.134:3006/api';
//export const BASE_URL = 'http://103.87.173.134:3006';

//103.30.74.171:3000/
// export const API_URL = 'https://stagingapi.kiwitravel.it/api';
// export const BASE_URL = 'https://stagingapi.kiwitravel.it';

export const API_URL = "https://api.kiwitravel.it/api";
export const BASE_URL = "https://api.kiwitravel.it";

// export const API_URL = "http://192.168.1.111:3001/api";
// export const BASE_URL = "http://192.168.1.111:3001";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    userId: null,
    name: "",
    user_type: "",
    dob: null,
    address: null,
  });

  const setDetails = ({ name, userId, user_type, dob, address }) => {
    setUser({
      name,
      userId,
      user_type,
      dob,
      address,
    });
  };

  return (
    <UserContext.Provider value={{ user, setDetails }}>
      {children}
    </UserContext.Provider>
  );
};

export const LanguageContext = createContext();
export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    return localStorage.getItem("appLanguage") || "en";
  });
  const setLanguage = (lang) => {
    localStorage.setItem("appLanguage", lang);
    setLanguageState(lang);
    window.location.reload(); // Reloads the page
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// export const GOOGLE_CLIENT_ID = '393417566289-sakc5fs0f0aomcuj80acud0ghfqiot4f.apps.googleusercontent.com';

export const GOOGLE_CLIENT_ID =
  "45509565768-56nrunga9j37dqiaikhu8bjktm26fct6.apps.googleusercontent.com";
